var path = './document-viewer/documentViewEditDisabledTooltip.html';
var html = "<div ng-bind-html=\"getEditDisabledReason(metadata)? getEditDisabledReason(metadata): ('FILE_ACTIONS.EDIT'| translate)\" ng-click=\"downloadClicked()\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;